export const getIsCarregandoRelatorioIPBDetalhado =
  (state) => state.relatoriosIPB.isCarregandoRelatorioIPBDetalhado

export const getIsCarregandoRelatorioIPBResumido =
  (state) => state.relatoriosIPB.isCarregandoRelatorioIPBResumido

export const getIsCarregandoRelatorioIPBGeral =
  (state) => state.relatoriosIPB.isCarregandoRelatorioIPBGeral
